// Arabic strings for departments, HR mapping and site retention overrides — DEVELOPMENT DRAFT by
// Claude (PD-011); unreviewed until decision H-10. English source: en-model.ts.
import type { enModel } from './en-model.ts';
import type { Message } from './types.ts';

export const arModel: { readonly [K in keyof typeof enModel]: Message } = {
  'mdl.v.departmentInactive': 'هذا القسم غير نشط. اختر قسماً نشطاً.',
  'mdl.v.departmentNameTaken': 'يوجد هنا قسم نشط بهذا الاسم بالفعل.',
  'mdl.v.departmentScope': 'أقسام الموارد البشرية تنطبق على المؤسسة كاملة. اختر قسماً على مستوى المؤسسة.',
  'mdl.v.hrDepartmentLinked': 'قسم الموارد البشرية هذا مرتبط بالفعل بقسم آخر.',
  'mdl.v.notSiteClass': 'تُحفظ فئة السجلات هذه لكل شخص أو للمؤسسة، فلا يمكن للموقع تجاوزها.',
  'mdl.api.departmentSourceOwned': 'يأتي هذا القسم من نظام الموارد البشرية. غيّره هناك وستطبّقه المزامنة التالية.',
  'mdl.api.hrSyncDisabled': 'مزامنة الموارد البشرية متوقفة لهذا الموصل.',
  'mdl.api.noSiteRetention': 'لا يوجد لهذا الموقع تجاوز منشور لمدد الاحتفاظ.',
  'mdl.api.siteRetentionEmpty': 'لا تحتوي المسودة على مدد. لإعادة الموقع إلى القواعد المشتركة، أزل التجاوز المنشور بدلاً من ذلك.',
  'mdl.api.siteRetentionProblems': 'صحّح المدد المشار إليها قبل النشر.',
  'mdl.api.sitePolicyChanged': 'تغيّرت سياسة الاحتفاظ في المؤسسة منذ المعاينة. راجع المعاينة مرة أخرى.',
  'ppl.ra.reason.host_inactive_hr': 'غادر نظام الموارد البشرية',
  'pv.class.ai_records': 'سجلات المساعدة بالذكاء الاصطناعي',
  'pv.class.candidate_records': 'ملاحظات المرشحين (الموارد البشرية)',

  'mdl.tab.departments': 'الأقسام',
  'mdl.dep.title': 'الأقسام',
  'mdl.dep.intro': 'الأقسام مراجع مشتركة. تغيير اسم قسم يغيّر الاسم لدى المضيفين المنتمين إليه فقط ولا ينقل أحداً آخر. يحتفظ القسم غير النشط بمضيفيه وسجله لكن لا يمكن اختياره لتعيينات جديدة.',
  'mdl.dep.none': 'لا توجد أقسام بعد.',
  'mdl.dep.col.name': 'القسم',
  'mdl.dep.col.scope': 'ينطبق على',
  'mdl.dep.col.source': 'المصدر',
  'mdl.dep.col.hosts': 'المضيفون',
  'mdl.dep.col.status': 'الحالة',
  'mdl.dep.orgWide': 'المؤسسة كاملة',
  'mdl.dep.source.manual': 'أُدخل هنا',
  'mdl.dep.source.migrated': 'منسوخ من نص حر سابق',
  'mdl.dep.source.directory': 'دليل الموظفين',
  'mdl.dep.source.import': 'استيراد',
  'mdl.dep.source.hr': 'نظام الموارد البشرية',
  'mdl.dep.hrId': 'معرّف الموارد البشرية {id}',
  'mdl.dep.add': 'إضافة قسم',
  'mdl.dep.name': 'الاسم',
  'mdl.dep.site': 'الموقع',
  'mdl.dep.siteHint': 'اتركه فارغاً لقسم يُستخدم على مستوى المؤسسة.',
  'mdl.dep.reason': 'السبب',
  'mdl.dep.rename': 'إعادة تسمية',
  'mdl.dep.renameTitle': 'إعادة تسمية {name}',
  'mdl.dep.renameNote': 'سيظهر الاسم الجديد لدى المضيفين في هذا القسم ({count}). لن ينتقل أي مضيف إلى قسم آخر.',
  'mdl.dep.deactivate': 'إلغاء التنشيط',
  'mdl.dep.reactivate': 'إعادة التنشيط',
  'mdl.dep.deactivateTitle': 'إلغاء تنشيط {name}',
  'mdl.dep.deactivateNote': 'يحتفظ المضيفون في هذا القسم ({count}) به وبسجله. ولا يمكن اختياره بعد الآن لتعيينات جديدة.',
  'mdl.dep.reactivateTitle': 'إعادة تنشيط {name}',
  'mdl.dep.history': 'السجل',
  'mdl.dep.historyTitle': 'سجل {name}',
  'mdl.dep.historyNone': 'لا توجد تغييرات مسجلة.',
  'mdl.dep.kind.created': 'أُنشئ',
  'mdl.dep.kind.renamed': 'أُعيدت تسميته من «{old}» إلى «{new}»',
  'mdl.dep.kind.deactivated': 'أُلغي تنشيطه',
  'mdl.dep.kind.reactivated': 'أُعيد تنشيطه',
  'mdl.dep.kind.linked': 'رُبط بنظام الموارد البشرية',
  'mdl.dep.hostsAffected': '{count} مضيف',
  'mdl.dep.byRun': 'مزامنة الموارد البشرية',
  'mdl.dep.hrOwned': 'يُدار في نظام الموارد البشرية',
  'mdl.dep.showInactive': 'عرض الأقسام غير النشطة',
  'mdl.dep.pick': 'القسم',
  'mdl.dep.pickNone': 'بلا قسم',
  'mdl.dep.pickHint': 'اختر من قائمة الأقسام. تُدار القائمة من المستخدمون ← الأقسام.',

  'mdl.tab.hr': 'ربط الموارد البشرية',
  'mdl.hr.title': 'ربط سمات الموارد البشرية',
  'mdl.hr.intro': 'اختر سمات الموارد البشرية التي يُسمح لـ Passage بقراءتها. تُستخدم السمات المرتبطة فقط؛ ويُتجاهل كل ما عداها في سجل الموارد البشرية ولا يُخزَّن أبداً. يُطابَق المضيفون بمعرّف الموظف في الموارد البشرية، وليس بالبريد الإلكتروني أبداً.',
  'mdl.hr.none': 'لا يوجد موصل موارد بشرية مُعدّ. يضيفه مشغّل التكامل ويختبره من صفحة التكاملات.',
  'mdl.hr.simulator': 'محاكي للتطوير — ليس نظام موارد بشرية حقيقياً',
  'mdl.hr.blocked': 'غير متاح بعد: {reason}',
  'mdl.hr.connector': 'الموصل',
  'mdl.hr.connectorStatus': 'الاتصال',
  'mdl.hr.syncEnabled': 'المزامنة مفعّلة',
  'mdl.hr.syncDisabled': 'المزامنة متوقفة',
  'mdl.hr.hosts': '{count} مضيف ({inactive} غير نشط)',
  'mdl.hr.departments': '{active} قسم ({inactive} غير نشط)',
  'mdl.hr.editMapping': 'تعديل الربط',
  'mdl.hr.mappingTitle': 'الربط لـ {name}',
  'mdl.hr.externalId': 'معرّف الموظف الخارجي',
  'mdl.hr.externalIdNote': 'دائماً معرّف الموظف في الموارد البشرية. يحدد المضيف ولا يتغير.',
  'mdl.hr.field.department': 'القسم (السمة التي تحمل معرّف القسم في الموارد البشرية)',
  'mdl.hr.field.jobTitle': 'المسمى الوظيفي',
  'mdl.hr.field.employeeNumber': 'الرقم الوظيفي',
  'mdl.hr.field.officeSiteCode': 'رمز موقع المكتب',
  'mdl.hr.fieldHint': 'اسم السمة في الموارد البشرية. اتركه فارغاً لإبقاء هذا الحقل خارج المزامنة.',
  'mdl.hr.enabled': 'المزامنة من هذا الموصل',
  'mdl.hr.maxDeactivation': 'أوقف التشغيل للمراجعة إذا كانت نسبة المضيفين الذين سيصبحون غير نشطين أكبر من (%)',
  'mdl.hr.reason': 'سبب التغيير',
  'mdl.hr.save': 'حفظ الربط',
  'mdl.hr.run': 'زامن الآن',
  'mdl.hr.runConfirm': 'زامن واقبل حالات إلغاء التنشيط الموقوفة',
  'mdl.hr.lastRun': 'آخر تشغيل {when}: {outcome}',
  'mdl.hr.outcome.succeeded': 'اكتمل',
  'mdl.hr.outcome.held': 'موقوف للمراجعة',
  'mdl.hr.outcome.failed': 'فشل',
  'mdl.hr.error': 'السبب: {code}',
  'mdl.hr.counts': '{created} أُضيف · {updated} حُدّث · {deactivated} أصبح غير نشط · {unchanged} دون تغيير',
  'mdl.hr.deptCounts': 'الأقسام: {created} أُضيف · {renamed} أُعيدت تسميته · {deactivated} أصبح غير نشط · {reactivated} أُعيد تنشيطه',
  'mdl.hr.conflicts': 'تعارضات تحتاج إلى حل',
  'mdl.hr.noConflicts': 'لا توجد تعارضات.',
  'mdl.hr.conflict.external': 'معرّف الموارد البشرية',
  'mdl.hr.conflict.kind': 'المشكلة',
  'mdl.hr.conflict.action': 'الخطوة التالية',
  'mdl.hr.kind.host_exists': 'يوجد مضيف بهذا البريد الإلكتروني ولم يُستولَ عليه.',
  'mdl.hr.kind.employee_number_in_use': 'الرقم الوظيفي مستخدم لمضيف آخر.',
  'mdl.hr.kind.duplicate_external_id': 'المعرّف مكرر أو يتبع مصدراً آخر.',
  'mdl.hr.kind.invalid_entry': 'سجل الموارد البشرية ناقص أو غير صالح.',
  'mdl.hr.kind.office_site_unknown': 'رمز موقع المكتب لا يطابق أي موقع.',
  'mdl.hr.kind.deactivation_threshold': 'سيصبح عدد كبير من المضيفين غير نشطين؛ أُوقف التشغيل.',
  'mdl.hr.kind.administrator_hold': 'ألغى مسؤول تنشيط هذا المضيف؛ ويبقى غير نشط.',
  'mdl.hr.kind.account_linked_elsewhere': 'الحساب مرتبط بمضيف آخر.',
  'mdl.hr.kind.department_unknown': 'قسم الموظف في الموارد البشرية غير مربوط؛ يحتفظ المضيف بقسمه الحالي.',
  'mdl.hr.kind.department_name_in_use': 'يوجد قسم آخر باسم «{name}»؛ لم يُدمج شيء.',
  'mdl.hr.kind.department_invalid': 'سجل قسم في الموارد البشرية ناقص.',
  'mdl.hr.kind.other': 'يحتاج إلى مراجعة.',
  'mdl.hr.linkHost': 'ربط مضيف موجود',
  'mdl.hr.linkHostTitle': 'ربط مضيف بالموظف {id} في الموارد البشرية',
  'mdl.hr.linkHostNote': 'يحتفظ المضيف بمعرّفه وزياراته وسجله؛ وستأتي حقوله المربوطة من نظام الموارد البشرية بدءاً من التشغيل التالي.',
  'mdl.hr.host': 'المضيف',
  'mdl.hr.linkDepartment': 'ربط قسم موجود',
  'mdl.hr.linkDepartmentTitle': 'ربط قسم الموارد البشرية {id}',
  'mdl.hr.linkDepartmentNote': 'يحتفظ القسم بمعرّفه ومضيفيه؛ ويتبع اسمه نظام الموارد البشرية بدءاً من التشغيل التالي.',
  'mdl.hr.department': 'القسم',
  'mdl.hr.link': 'ربط',
  'mdl.hr.runs': 'عمليات التشغيل الأخيرة',

  'mdl.sr.title': 'الاحتفاظ حسب الموقع',
  'mdl.sr.intro': 'يمكن لموقع أن يحتفظ ببعض السجلات مدة مختلفة عن القواعد المشتركة، مثلاً بسبب متطلبات محلية. تُدخل أنت المدد؛ ولا يقترح Passage أي مدة.',
  'mdl.sr.precedence': 'المدة المطبقة: مدة الموقع لنوع الزائر، ثم مدة المؤسسة لذلك النوع، ثم مدة الموقع لفئة السجلات، ثم القاعدة المشتركة.',
  'mdl.sr.noPolicy': 'انشر قواعد الاحتفاظ للمؤسسة أولاً. تُبنى تجاوزات المواقع عليها.',
  'mdl.sr.site': 'الموقع',
  'mdl.sr.status': 'التجاوز',
  'mdl.sr.none': 'القواعد المشتركة',
  'mdl.sr.published': 'الإصدار {number} · {count} مدة',
  'mdl.sr.draft': 'مسودة {number}',
  'mdl.sr.open': 'فتح',
  'mdl.sr.detailTitle': 'الاحتفاظ في {site}',
  'mdl.sr.effective': 'المطبّق في هذا الموقع',
  'mdl.sr.class': 'فئة السجلات',
  'mdl.sr.type': 'نوع الزائر',
  'mdl.sr.allTypes': 'كل أنواع الزوار',
  'mdl.sr.days': 'المدة',
  'mdl.sr.source': 'المصدر',
  'mdl.sr.source.site_visitor_type': 'هذا الموقع، لنوع الزائر',
  'mdl.sr.source.organisation_visitor_type': 'المؤسسة، لنوع الزائر',
  'mdl.sr.source.site': 'هذا الموقع',
  'mdl.sr.source.organisation': 'القاعدة المشتركة',
  'mdl.sr.diff': 'التجاوز المحلي مقارنة بالقاعدة المشتركة',
  'mdl.sr.override': 'هذا الموقع',
  'mdl.sr.shared': 'القاعدة المشتركة',
  'mdl.sr.draftTitle': 'مسودة لهذا الموقع',
  'mdl.sr.draftNone': 'لا توجد مسودة. أدخل مدة للبدء.',
  'mdl.sr.daysFor': 'الأيام لـ {name}',
  'mdl.sr.clear': 'مسح',
  'mdl.sr.addType': 'إضافة مدة لنوع زائر',
  'mdl.sr.typeCode': 'رمز نوع الزائر',
  'mdl.sr.saveDraft': 'حفظ المسودة',
  'mdl.sr.publish': 'النشر لهذا الموقع',
  'mdl.sr.discard': 'تجاهل المسودة',
  'mdl.sr.problems': 'مشكلات يجب حلها قبل النشر: {count}',
  'mdl.sr.problem.unknown_class': 'فئة سجلات غير معروفة',
  'mdl.sr.problem.not_site_scoped': 'لا تُحفظ لكل موقع',
  'mdl.sr.problem.out_of_range': 'خارج النطاق',
  'mdl.sr.problem.not_per_type': 'لا تُحدد لكل نوع زائر',
  'mdl.sr.problem.organisation_unconfigured': 'لا توجد قاعدة مشتركة لهذه الفئة بعد',
  'mdl.sr.history': 'الإصدارات',
  'mdl.sr.basedOn': 'نُشر استناداً إلى الإصدار {number} من قواعد المؤسسة',
  'mdl.sr.statusLabel.published': 'منشور',
  'mdl.sr.statusLabel.superseded': 'مستبدل',
  'mdl.sr.statusLabel.discarded': 'متجاهَل',
  'mdl.sr.statusLabel.removed': 'مُزال',
  'mdl.sr.statusLabel.draft': 'مسودة',
  'mdl.sr.removedBecause': 'أُزيل: {reason}',
  'mdl.sr.remove': 'إزالة التجاوز…',
  'mdl.sr.removeTitle': 'إزالة تجاوز الاحتفاظ لـ {site}',
  'mdl.sr.removeIntro': 'بعد الإزالة تُطبق هذه القواعد المشتركة في هذا الموقع. لا يُحذف شيء الآن؛ يسري التغيير في خطة الاحتفاظ التالية التي يراجعها شخص قبل تطبيق أي شيء.',
  'mdl.sr.becomes': 'تصبح',
  'mdl.sr.records': 'سجلات في هذا الموقع تتغير مدة احتفاظها الآن',
  'mdl.sr.becomesDue': '{count} تصبح مستحقة',
  'mdl.sr.noLongerDue': '{count} لم تعد مستحقة',
  'mdl.sr.truncated': 'على الأقل هذا العدد (تتوقف المعاينة عند حد التخطيط).',
  'mdl.sr.noRecordChange': 'لا يتغير استحقاق أي سجل اليوم.',
  'mdl.sr.removeReason': 'سبب الإزالة',
  'mdl.sr.confirmRemove': 'إزالة التجاوز',
};
